module.exports = __webpack_public_path__ + "static/media/fb.a265564c.webp";